/*
  hbi-video-facade.js (2026-10-24)
  Product "Videos" tab: show a sharp YouTube thumbnail + play button instead of
  loading YouTube's player for every video on page load. The real player loads
  only when the shopper clicks play.

  Why:
  - YouTube's player is ~1.4 MB per page and loaded even with the Videos tab closed.
  - The embedded player's poster is a small, blurry image; YouTube also has a
    sharp 1280x720 thumbnail (maxresdefault) for most videos - we use that,
    falling back to sddefault / hqdefault when a video doesn't have one.

  Markup comes from the custom.video_html metafield. sections/product-tabs.liquid
  renames YouTube iframes' src to data-hbi-yt so nothing loads before this script
  runs. Also handles old Magento-era embeds (src="about:blank" data-src="...youtube...")
  that never played on the new site. Anything it can't read is left exactly as it was.
*/
(function () {
  var ID_RE = /youtube(?:-nocookie)?\.com\/embed\/(?:v=)?([A-Za-z0-9_-]{11})(?=[?&#"]|$)/;
  var THUMBS = ['maxresdefault', 'sddefault', 'hqdefault'];

  function injectStyles() {
    if (document.getElementById('hbi-yt-styles')) return;
    var css =
      '.hbi-yt{position:relative;display:block;width:100%;padding:0;border:0;margin:0;cursor:pointer;background:#000;overflow:hidden;aspect-ratio:16/9}' +
      '.hbi-yt img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;transition:opacity .2s}' +
      '.hbi-yt:hover img{opacity:.9}' +
      '.hbi-yt__play{position:absolute;left:50%;top:50%;width:68px;height:48px;transform:translate(-50%,-50%);pointer-events:none}' +
      '.hbi-yt:focus-visible{outline:3px solid #b65d21;outline-offset:2px}' +
      '.hbi-yt--sized{max-width:100%;height:auto}';
    var s = document.createElement('style');
    s.id = 'hbi-yt-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function playIcon() {
    return '<svg class="hbi-yt__play" viewBox="0 0 68 48" aria-hidden="true" focusable="false">' +
      '<path d="M66.5 7.7a8.5 8.5 0 0 0-6-6C55.2.3 34 .3 34 .3S12.8.3 7.5 1.7a8.5 8.5 0 0 0-6 6C.1 13 .1 24 .1 24s0 11 1.4 16.3a8.5 8.5 0 0 0 6 6C12.8 47.7 34 47.7 34 47.7s21.2 0 26.5-1.4a8.5 8.5 0 0 0 6-6C67.9 35 67.9 24 67.9 24s0-11-1.4-16.3z" fill="#f00"/>' +
      '<path d="M45 24 27 14v20" fill="#fff"/></svg>';
  }

  function setThumb(img, id, i) {
    img.onerror = function () { if (i + 1 < THUMBS.length) setThumb(img, id, i + 1); };
    img.src = 'https://i.ytimg.com/vi/' + id + '/' + THUMBS[i] + '.jpg';
  }

  function upgrade(frame) {
    var url = frame.getAttribute('data-hbi-yt') || frame.getAttribute('data-src') || '';
    var m = url.match(ID_RE);
    if (!m) {
      // Not a readable YouTube link: put it back exactly as the metafield had it.
      if (frame.hasAttribute('data-hbi-yt')) {
        frame.setAttribute('src', url);
        frame.removeAttribute('data-hbi-yt');
      }
      return;
    }
    var id = m[1];
    var title = frame.getAttribute('title') || 'Product video';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hbi-yt';
    btn.setAttribute('aria-label', 'Play video: ' + title);
    var style = frame.getAttribute('style');
    if (style) btn.setAttribute('style', style);
    var w = parseInt(frame.getAttribute('width'), 10);
    if (!style && w) { btn.classList.add('hbi-yt--sized'); btn.style.width = w + 'px'; }

    var img = document.createElement('img');
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.width = 1280;
    img.height = 720;
    setThumb(img, id, 0);
    btn.appendChild(img);
    btn.insertAdjacentHTML('beforeend', playIcon());

    btn.addEventListener('click', function () {
      var player = frame.cloneNode(false);
      player.removeAttribute('data-hbi-yt');
      player.removeAttribute('data-src');
      player.removeAttribute('loading');
      var allow = player.getAttribute('allow') || '';
      if (allow.indexOf('autoplay') === -1) player.setAttribute('allow', (allow ? allow + '; ' : '') + 'autoplay');
      if (!player.hasAttribute('allowfullscreen')) player.setAttribute('allowfullscreen', '');
      var clean = 'https://www.youtube.com/embed/' + id;
      var q = url.split('?')[1];
      player.setAttribute('src', clean + '?' + (q ? q + '&' : '') + 'autoplay=1');
      btn.replaceWith(player);
      player.focus();
    });

    frame.replaceWith(btn);
  }

  function init() {
    var frames = document.querySelectorAll('iframe[data-hbi-yt], iframe[data-src*="youtube.com/embed/"]');
    if (!frames.length) return;
    injectStyles();
    for (var i = 0; i < frames.length; i++) upgrade(frames[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
